import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { StudyFileV1 } from '@csp/dmdp-api-file-storage-studydocs-dto';
import { RoleType } from '@csp/dmdp-api-common-dto';
import { EnumUtil } from '@csp/csp-common-enum-util';
import { Maybe, User } from '@csp/csp-common-model';
import { OrgV1 } from '@csp/dmdp-api-org-dto';
import { OrgMapper } from '@csp/csp-common-org';
import { StudyDocumentsFolder } from '../model/StudyDocumentsFolder';
import { StudyDocumentsFileDetails } from '../model/StudyDocumentsFileDetails';
import { StudyDocumentsFile } from '../model/StudyDocumentsFile';
import { Domain } from '../model/Domain';

const from = (studyFileV1: StudyFileV1): StudyDocumentsFile => ({
  eventId: studyFileV1.eventId,
  id: studyFileV1.studyFileId,
  name: studyFileV1.fileName,
  version: studyFileV1.version,
  isTrash: studyFileV1.trash,
  roles: (studyFileV1.roles ?? []).map(role => EnumUtil.fromStringOrError(role, RoleType)),
  createdAt: ZonedDateTimeFactory.fromZonedDateTimeString(studyFileV1.audit.createdAt),
  orgIds: studyFileV1.orgIds ?? [],
  domains: studyFileV1.domains.map(domain => EnumUtil.fromStringOrError(domain, Domain)),
});

const toStudyDocumentsFileDetails = (
  studyFileV1: StudyFileV1,
  user: Maybe<User>,
  orgV1s: OrgV1[],
  folders: StudyDocumentsFolder[],
): StudyDocumentsFileDetails => ({
  eventId: studyFileV1.eventId,
  id: studyFileV1.studyFileId,
  name: studyFileV1.fileName,
  version: studyFileV1.version,
  roles: (studyFileV1.roles ?? []).map(role => EnumUtil.fromStringOrError(role, RoleType)),
  createdAt: ZonedDateTimeFactory.fromZonedDateTimeString(studyFileV1.audit.createdAt),
  createdBy: user?.displayName,
  orgs: orgV1s.map(OrgMapper.fromOrgV1),
  folders,
  pinnedLocations: (studyFileV1.domains ?? []).map(domain => EnumUtil.fromStringOrError(domain, Domain)),
});

export const StudyDocumentsFileMapper = {
  from,
  toStudyDocumentsFileDetails,
};
